// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__seWjm","title":"AfterFrontImage_title__3xMQs"};